import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';

// Données des bulletins socio-économiques
const bulletinsStatistiquesData = [
  {
    "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE BUJUMBURA",
    "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE BUJUMBURA, ÉDITION 2019-2020",
    "link": "/documents/socio_economic_profile/Profil-Bujumbura-2009.pdf",
    "date": "2020-01-01",
    "description": "La province de Bujumbura (710 458 habitants en 2019-2020) fait face à des défis multisectoriels : pression éducative (52% de réussite au concours national), tensions agricoles (riziculture à Mutimbuzi), et lacunes sanitaires (manque de personnel et d'infrastructures), malgré une démographie croissante concentrée à Kanyosha.",
    "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_buja.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE BURURI",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE BURURI, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Bururi-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Bururi (2019-2020) révèle une concentration démographique à Bururi et Mugamba, avec des défis sanitaires (58 formations) et éducatifs (50,6% de réussite), un élevage bovin dominant (102 474 têtes), et une inflation marquée (éducation et alimentation) malgré les efforts culturels.",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_buru.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE CANKUZO",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE CANKUZO, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Cankuzo-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Cankuzo (2019-2020) se distingue par son excellence éducative (76,7% de réussite, 3ème national) et son agriculture dynamique (café, palmier), mais fait face à des défis sanitaires (paludisme dominant), hydriques (507 bornes fontaines) et sécuritaires (878 affaires en 2019).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_canku.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE CIBITOKE",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE CIBITOKE, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Cibitoke-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Cibitoke (2019-2020) affiche une croissance démographique (688 583 à 703 758 habitants), une performance scolaire remarquable (60,5% de réussite, 3ème national) et une économie dynamique (agriculture diversifiée, potentiel minier), malgré des besoins persistants en infrastructures sanitaires et hydrauliques (450 bornes fontaines).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_cibi.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE GITEGA",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE GITEGA, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Gitega-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Gitega (2019) compte 925 149 habitants (52,4% de femmes, 38% de moins de 15 ans), avec des défis éducatifs (abandons scolaires, grossesses précoces) et sanitaires (380 000 cas de paludisme), malgré 77 centres de santé et une agriculture vivrière peu productive (outils rudimentaires, semences non améliorées).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_gite.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE KARUSI",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE KARUSI, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Karusi-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Karusi (2019-2020) compte 925 149 habitants (densité : 448 hab/km², +2,3%/an), avec 40 centres de santé luttant contre le paludisme. L'agriculture (café/vivriers) et l'artisanat dominent, mais subissent la pression foncière et environnementale, malgré des progrès dans l'accès à l'eau.",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_karu.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE KAYANZA",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE KAYANZA, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Kayanza-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Kayanza (2019-2020) affiche une densité record (1 215 hab/km²) avec 894 781 habitants, un système de santé solide (40 établissements, 91 971 bénéficiaires de planning familial) et une économie agricole fragile (dégradation des sols), malgré une inflation élevée (+12,1% en 2020).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_kaya.PNG"
},
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE KIRUNDO",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE KIRUNDO, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Kirundo-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Kirundo (2019-2020) présente une densité élevée (552 hab/km²) avec 51,6% de femmes, un déficit en centres de santé (63/94 requis) et une économie agricole fragile face à l'inflation (+7,2%, santé +30,5%), malgré des progrès en vaccination et dynamisme démographique (Busoni).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_kiru.PNG"
},{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE MAKAMBA",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE MAKAMBA, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Makamba-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Makamba (2019-2020) affiche une croissance démographique rapide (+26,5% depuis 2008, 586 025 hab.) avec 80% de jeunes, un système éducatif résilient (taux d'abandon <11%) et sanitaire actif (90 centres, 33 267 accouchements), mais vulnérable au paludisme (132 108 cas) et dépendant d'une agriculture vivrière (riz: 3,6T/ha).",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_maka.PNG"
},
 
{
  "province": "BUREAU PROVINCIAL DE LA STATISTIQUE DE MUYINGA",
  "title": "PROFIL SOCIO-ÉCONOMIQUE DE LA PROVINCE MUYINGA, ÉDITION 2019-2020",
  "link": "/documents/socio_economic_profile/Profil-Muyinga-20092022.pdf",
  "date": "2020-01-01",
  "description": "La province de Muyinga (2019-2020) compte 945 770 habitants (51,3% de femmes), avec des disparités démographiques (309-670 hab/km²), d'excellents résultats scolaires (82,77% de réussite) mais des défis sanitaires (769 479 cas de paludisme) et économiques (inflation à +11,1%), malgré une agriculture dynamique.",
  "image": "/assets/SocioEconomicProfile/SocioEconomicProfile_muyi.PNG"
}
];

function SocioEconomicProfile() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsStatistiquesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredBulletins(bulletinsStatistiquesData);
    } else {
      const filtered = bulletinsStatistiquesData.filter((bulletin) => {
        const bulletinYear = new Date(bulletin.date).getFullYear();
        return bulletinYear === parseInt(year);
      });
      // Triez les bulletins filtrés par date, du plus récent au plus ancien
      setFilteredBulletins(filtered.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#673AB7',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54',
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: '#6B778C',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '70px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Profil socio-économique
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
               Cette section présente une analyse approfondie des profils socio-économiques des provinces du Burundi. À travers des données clés sur la population, la santé, l'éducation et les conditions de vie, ce document met en lumière les défis et les opportunités qui se présentent dans chaque région. L'objectif est de fournir des informations pertinentes et précises pour mieux comprendre le contexte socio-économique du pays et d'encourager des initiatives de développement durable et harmonieux dans les différentes provinces.
           </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
            >
              <MenuItem value="Tous">Tous les profils</MenuItem>
              {[...new Set(bulletinsStatistiquesData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={bulletin.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={bulletin.image}
                        alt={bulletin.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={bulletin.link}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {<DownloadIcon />}{bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="h6" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.province}
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de profils
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default SocioEconomicProfile;